import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { GlobalVariablesService } from '../../../core/services/global-variables.service';
import { Guid } from '../../../core/constants/constants';
import { CustomReportEditor } from './models/custom-report-editor.model';
import { UtilityService } from '@app/modules/live/services/utility.service';

@Injectable()
export class CustomReportService {

    public customReports: CustomReportEditor.CustomReport[] = []; // Custom reports array

    constructor(
        private http: HttpClient,
        private varService: GlobalVariablesService,
        private utility: UtilityService) { }


    // Fetch user custom reports
    public getUserCustomReports(): Observable<CustomReportEditor.CustomReport[]> {
        const url = `${this.varService.apiV2Address}/reports/custom-reports`;
        return this.http.get<CustomReportEditor.CustomReport[]>(url).pipe(
            map((reports: CustomReportEditor.CustomReport[]) => {
                return reports.map((reportData) => {
                    // Yeni bir CustomReport instance'ı oluştur ve veriyi içine aktar
                    const report = Object.assign(new CustomReportEditor.CustomReport(), reportData);

                    // Eğer ikon string olarak geldiyse çözümle
                    if (report && report.icon && typeof report.icon === 'string') {
                        report.icon = this.utility.resolveIcon(report.icon);
                    }

                    // gridState'i set et (bu setter içinde working hours parse edilecek)
                    if (reportData.gridState) {
                        report.gridState = reportData.gridState;
                    }

                    console.log('Loaded report from server:', report.name, 'Working hours:', report.state.workingHours);

                    return report;
                });
            })
        );
    }
    // Add a new custom report
    public addCustomReport(report: CustomReportEditor.CustomReport): Observable<CustomReportEditor.CustomReport> {
        const url = `${this.varService.apiV2Address}/reports/custom-reports`;
        const reportToSend = this.serializeReport(report);
        return this.http.post<CustomReportEditor.CustomReport>(url, reportToSend).pipe(
            map((responseData) => {
                // Yeni CustomReport instance oluştur
                const newReport = Object.assign(new CustomReportEditor.CustomReport(), responseData);
                
                // Resolve the icon from string to IconProp
                if (newReport && newReport.icon && typeof newReport.icon === 'string') {
                    newReport.icon = this.utility.resolveIcon(newReport.icon);
                }
                
                // gridState'i set et
                if (responseData.gridState) {
                    newReport.gridState = responseData.gridState;
                }
                
                return newReport;
            })
        );
    }

    // Update an existing custom report
    public updateCustomReport(report: CustomReportEditor.CustomReport): Observable<CustomReportEditor.CustomReport> {
        const url = `${this.varService.apiV2Address}/reports/custom-reports/${report.id}`;
        const reportToSend = this.serializeReport(report);
        return this.http.put<CustomReportEditor.CustomReport>(url, reportToSend).pipe(
            map((responseData) => {
                // Yeni CustomReport instance oluştur
                const updatedReport = Object.assign(new CustomReportEditor.CustomReport(), responseData);
                
                // Resolve the icon from string to IconProp
                if (updatedReport && updatedReport.icon && typeof updatedReport.icon === 'string') {
                    updatedReport.icon = this.utility.resolveIcon(updatedReport.icon);
                }
                
                // gridState'i set et
                if (responseData.gridState) {
                    updatedReport.gridState = responseData.gridState;
                }
                
                return updatedReport;
            })
        );
    }

    // Delete a custom report
    public deleteCustomReport(reportId: Guid): Observable<CustomReportEditor.CustomReport> {
        const url = `${this.varService.apiV2Address}/reports/custom-reports/${reportId}`;
        return this.http.delete<CustomReportEditor.CustomReport>(url);
    }

    // Helper method to serialize the report before sending to the server
    private serializeReport(report: CustomReportEditor.CustomReport | any): any {
        const { state, ...reportWithoutState } = report;
        return {
            ...reportWithoutState,
            icon: report.icon ? JSON.stringify(report.icon) : null, // Convert IconProp to JSON string
            gridState: JSON.stringify(report.state) // Convert state object to JSON string
            // state property çıkarıldı
        };
    }
}